import request from "@/common/request/request";
import {handleRes} from "@vUtils";

interface HandleResInterface {
  success: any,
  fail: any,
}

const statistics = {
  getFengChaoMonthList: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETStatisticsMonthQoq(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  },
  getFengChaoWeekList: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETStatisticsWeekQoq(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  },
  getFengChaoDayPlayRankList: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETStatisticsDayPlayRank(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  },


  getFengChaoCountNum: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETStatisticsStatisticsNum(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  },
  getStatisticsSubCompany: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETStatisticsSubCompany(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  },


  getYuntingCountData: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETSsoApiParkingReport(params, {
        host: window.config.yunTingSso
      });
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  },
  getHuolianCountData: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETParkingsReport(params, {
        host: window.config.huolianApi
      });
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  }


};

export default statistics;
